import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

import { MenuElement } from "../common-style";
import { StyledStaffLines } from "../StaffLines";
import { IStyleProps } from "../interfaces";

export const StyledNavLeft = styled.div`
    transition: transform 400ms;
    display: flex;
`;

export const MenuItem = styled(Link)<IStyleProps>`
    ${MenuElement}
    margin-right: 12px;
`;

export const Logo = styled.div`
    margin-right: 12px;
    color: ${p => p.theme.c.snowOnActive};
    display: flex;
    align-items: center;
    position: relative;
    transition: 400ms;

    ${p =>
        p.theme.xs(css`
            margin-right: 0;
            width: 164px;
        `)}
    a {
        display: block;

        svg {
            display: block;
            fill: ${p => p.theme.c.snowOnActive};
        }
    }
`;

export const StyledStaffLinesLeft = styled.div`
    ${StyledStaffLines}
`;
